import cn from "classnames";
import React, { FC, useMemo } from "react";

import P from "@/apps/ui/components/P";

import { GetPartsWithPriceType } from "../../selectors/getPartsWithPrice";

import styleCss from "./style.css";

interface ListProps {
  parts: GetPartsWithPriceType;
}

const List: FC<ListProps> = function ({ parts }) {
  const isHasParts = useMemo(() => Array.isArray(parts) && parts.length > 0, [parts]);
  const isNotFoundShowed = parts === undefined ? false : !isHasParts;

  return (
    <>
      {isHasParts && (
        <table className={cn(styleCss.list, "mb-3")}>
          <tbody>
            <tr className={styleCss.header}>
              <th className={styleCss["left-col"]}>АРТИКУЛ</th>
              <th className={styleCss["right-col"]}>ЦЕНА (В РУБ.)*</th>
            </tr>
            {parts?.map(({ id, code, price }) => (
              <tr className={styleCss.main} key={id}>
                <td className={styleCss["left-col"]}>{code}</td>
                <th className={styleCss["right-col"]}>{Math.trunc(price || 0)}</th>
              </tr>
            ))}
          </tbody>
        </table>
      )}
      {isNotFoundShowed && <P>Запчасть не найдена</P>}
    </>
  );
};

export default List;
